import React, { Component } from 'react';
import FooterSettingComponent from '../Component/FooterSettingComponent';


class FooterPageSetting extends Component {
    render() {
        return (
            <div >
              <FooterSettingComponent/>
            </div>
        );
    }
}

export default FooterPageSetting;
